// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import axios from 'axios';
import Toasted from 'vue-toasted';
import firebase from 'firebase';

import store from './store';
import router from './Routes';
// import App from './App';
import App from './App.vue';
import { AuthMixin } from './mixins/auth';
import layoutMixin from './mixins/layout';
import VueTouch from 'vue-touch';
import { ClientTable } from 'vue-tables-2';
import VueTimepicker from 'vue2-timepicker';
import FunctionalCalendar from 'vue-functional-calendar';
import VCalendar from 'v-calendar';

// import config from './config';
import Widget from './components/Widget/Widget.vue';

const firebaseDevConfig = {
  apiKey: 'AIzaSyAZfPryIecj3JJyrkpUyFG_9diKIJSIiSw',
  authDomain: 'starchaser-dev.firebaseapp.com',
  databaseURL: 'https://starchaser-dev.firebaseio.com',
  projectId: 'starchaser-dev',
  storageBucket: 'starchaser-dev.appspot.com',
  messagingSenderId: '1015585154486',
  appId: '1:1015585154486:web:d7dd98a82b1c9090a38d17'
};

var firebaseProdConfig = {
  apiKey: 'AIzaSyDiwyYTCuJjcfT0_cgd2YMhIDr-OZMCqHU',
  authDomain: 'starchaser-70856.firebaseapp.com',
  databaseURL: 'https://starchaser-70856.firebaseio.com',
  projectId: 'starchaser-70856',
  storageBucket: 'starchaser-70856.appspot.com',
  messagingSenderId: '807786112451',
  appId: '1:807786112451:web:24e244d1d559c304d0c976',
  measurementId: 'G-6PV0H275JF'
};

// const firebaseTestConfig = {
//   apiKey: "AIzaSyAtX3PldntJSJN2D-TjsxG3ZlwuAxZrg6c",
//   authDomain: "samf-test.firebaseapp.com",
//   databaseURL: "https://samf-test.firebaseio.com",
//   projectId: "samf-test",
//   storageBucket: "samf-test.appspot.com",
//   messagingSenderId: "26647683437",
//   appId: "1:26647683437:web:3fcf88c7190a9fa928ba64",
//   measurementId: "G-DXK6ZZB2N7"
// };

//TO CHANGE
const firebaseConfig = process.env.NODE_ENV === 'development' ? firebaseProdConfig : firebaseProdConfig;
// const firebaseConfig = process.env.NODE_ENV === 'development' ? firebaseDevConfig : firebaseProdConfig;

export const firebaseApp = firebase.initializeApp(firebaseConfig);
export const firestore = firebaseApp.firestore();
export const firebaseStorage = firebaseApp.storage().ref();
export const BADGES_STORAGE_FOLDER = 'badges';
export const AWARDS_STORAGE_FOLDER = 'awards';

// axios.defaults.baseURL = config.baseURLApi;
axios.defaults.headers.common['Content-Type'] = 'application/json';
const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}

Vue.use(BootstrapVue);
Vue.component('Widget', Widget);
Vue.use(Toasted, { duration: 10000 });
Vue.mixin(layoutMixin);
Vue.mixin(AuthMixin);
Vue.use(VueTouch);
Vue.use(VueTimepicker);
Vue.use(ClientTable, { theme: 'bootstrap4' });
Vue.use(FunctionalCalendar, {
  dayNames: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']
});
Vue.use(VCalendar);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
});
